import React from "react";
import { Formik, Form, Field } from "formik";
import { Grid, Button, SubmitButton, SearchSelect, makeStyles, Dialog, LinkAnimation } from "../../../../"; // import { Link } from "react-router-dom";

import { Debug } from "../../../../Molecules/Forms/Debug";
var useStyles = makeStyles(function (theme) {
  return {
    flex: {
      display: "flex",
      "align-items": "center",
      "justify-content": "flex-start"
    },
    w100: {
      width: "100%"
    },
    mr15: {
      marginRight: "15px"
    },
    dialogPaper: {
      minHeight: "50vh",
      maxHeight: "50vh"
    }
  };
});

var DialogAddChatUser = function DialogAddChatUser(props) {
  // console.log("DialogAddChatUser props", props);
  var classes = useStyles();
  var searchValue = props.searchValue,
      open = props.open,
      onClose = props.onClose,
      users = props.users,
      selectUser = props.selectUser,
      translation = props.translation,
      mobile = props.mobile;

  var getName = function getName(users, values) {
    var selectedUser = users && users.find(function (usr) {
      // console.log("usr", usr);
      return usr.value === values.username;
    });
    return selectedUser && selectedUser.label;
  };

  return /*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    className: classes.mh40vh,
    maxWidth: "lg",
    title: translation ? translation.title : "Search user",
    open: open,
    onClose: onClose,
    key: 0,
    dialogPaper: classes.dialogPaper
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: searchValue ? {
      username: searchValue
    } : {},
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;
      console.log("values", values);
      selectUser(values);
      onClose();
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting;
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "add-user",
        className: classes.form
      }, mobile ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.flex
      }, /*#__PURE__*/React.createElement(Field, {
        "data-cy": "users",
        name: "username",
        component: SearchSelect,
        options: users // style={{ width: "100%" }}
        ,
        className: classes.w100,
        variant: "outlined",
        value: values.username,
        mobile: mobile
      })), /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.flex
      }, /*#__PURE__*/React.createElement(LinkAnimation, {
        to: "/app/channels/direct/".concat(values.username),
        direction: "left",
        title: users && getName(users, values),
        classes: classes.fullCardLink
      }, /*#__PURE__*/React.createElement(Button, {
        style: {
          flex: 1
        },
        "data-cy": "submit",
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting
      }, translation ? translation.buttons.submit : "New direct message")))) : /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12
      }, /*#__PURE__*/React.createElement(Field, {
        "data-cy": "users",
        name: "username",
        component: SearchSelect,
        options: users,
        className: [classes.mr15, classes.w70].join(" "),
        variant: "outlined",
        value: values.username
      }), /*#__PURE__*/React.createElement(Button, {
        style: {
          flex: 1
        },
        "data-cy": "submit",
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, translation ? translation.buttons.select : "New direct message")));
    }
  }));
};

export { DialogAddChatUser };